import React from 'react'

import Widget from '../Widget'
import HorizontalBarChart from '../components/HorizontalBarChart'
import Subtitle from '../../../components/Subtitle'
import Box from '../../../components/Box'
import withFetch from '../../../infrastructure/withFetch'

const buildQuery = (eventId, startDate, endDate) =>
    `/api/visits/get-unique-visitors-by-referrers/${eventId}?startDate=${startDate}&endDate=${endDate}`

const Chart = withFetch(
    props => buildQuery(props.eventId, props.startDate, props.endDate),
    ({ status, data, retry }) => (
        <Widget status={status} data={data} retry={retry}>
            <HorizontalBarChart
                data={data.map(d => ({
                    x: d.referrerDomainName,
                    y: d.count,
                }))}
            />
        </Widget>
    ),
)

const tooltip = (
    <div>
        <p>
            This graph displays where each visitor (unique browser) who has
            visited your event page has come from to get there. It allows you to
            see which web sites are sending you the most traffic and generating
            interest in your event.
        </p>
        <p>
            If a visitor follows a link on Oztix to the event page, visited the
            event page from a link on the venue’s web site and did a Google
            search for the event page, they will be counted 3 times (one for
            each referrer).
        </p>
        <p>
            Note: Customers who have already purchased tickets to this event are
            included in this data.
        </p>
    </div>
)

const GetByReferrersWidget = ({ eventId, startDate, endDate }) => (
    <div>
        <Subtitle
            title="Referrers that contributed the most visitors"
            tooltip={tooltip}
        />
        <Box>
            <Chart eventId={eventId} startDate={startDate} endDate={endDate} />
        </Box>
    </div>
)

export default GetByReferrersWidget
